import React from 'react';
import './App.css';
import FormWidget from './FormWidget/FormWidget';

function App(props) {
  return (
    <div className="Wembii-Form">
      <FormWidget className="Wembii-Form" {...props} />
    </div>
  );
}

export default App;

